import { useState, useImperativeHandle } from "react";
import { useTranslation } from "next-i18next";
import { Modal, Button } from "antd";
import { useAppSelector } from "@/store/hooks";
import { RootState } from "@/store/index";
import defaultSettings from "@/config/settings";

/**
 * tip modal
 * @param open 是否显示
 * @returns
 */
const TipModal = (props: {
  onRef: any;
  title?: string;
  desc?: string;
  okText?: string;
  icon?: React.ReactNode;
  width?: number;
  okCallback?: Function;
  // 埋点场景名，区分同一个提示弹窗的不同业务来源
  qtScene?: string;
}) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState<boolean>(false);
  const appStore = useAppSelector((state: RootState) => state.app);
  const { isSmallScreen } = appStore;
  const { pcModalWidth, mobileModalWidth } = defaultSettings;
  const { icon, title, desc, okText, width, okCallback } = props;

  useImperativeHandle(props.onRef, () => {
    return {
      setOpen: setOpen,
    };
  });

  return (
    <Modal
      title={null}
      open={open}
      footer={null}
      centered
      width={width ? width : isSmallScreen ? mobileModalWidth : pcModalWidth}
      closeIcon={null}
      maskClosable={false}
    >
      <div className="flex flex-col items-center">
        {icon && <div className="mt-6 flex justify-center">{icon}</div>}
        {title && <div className={`text-xl font-semibold text-stone-800 ${icon ? "mt-2" : "mt-7"}`}>{title}</div>}
        {desc && <div className="mt-4 text-center text-sm text-stone-800">{desc}</div>}
        <Button
          type="primary"
          className="mb-1 mt-12 min-w-[80px]"
          onClick={() => {
            if (okCallback) {
              okCallback();
              setOpen(false);
            }
            setOpen(false);
          }}
          data-qt="modal_tip_ok_click"
          data-qt-scene={props.qtScene}
        >
          {okText ? okText : t("common.ok")}
        </Button>
      </div>
    </Modal>
  );
};

export default TipModal;
